// extracted by mini-css-extract-plugin
export var slideshow = "Carousel-module--slideshow--2o8fk";
export var container = "Carousel-module--container--2TqIM";
export var prev = "Carousel-module--prev--1vqA4";
export var next = "Carousel-module--next--dXR5c";
export var dot = "Carousel-module--dot--2xi1M";
export var selected = "Carousel-module--selected--2JKit";
export var fade = "Carousel-module--fade--vb1yw";
export var imgFormatting = "Carousel-module--imgFormatting--paLiC";